/**
 * Registration readiness, counted the way the backend counts it
 * (crm.helpers.readiness_counts): only APPLICABLE items. An item is not
 * applicable when the practice registered with its onboarding step switched off
 * (CRM → Settings → Registration onboarding) — it wasn't theirs to finish, so it
 * is greyed, left out of "X of Y" and "fully ready", and never gets a reminder.
 * Items from an older backend carry no `applicable` field and count as before.
 */
export const NOT_APPLICABLE_LABEL = "Not part of their onboarding";

export function isApplicable(item) {
  return !(item && item.applicable === false);
}

export function readinessCounts(items) {
  const list = Array.isArray(items) ? items : [];
  const applicable = list.filter(isApplicable);
  return {
    done: applicable.filter((i) => i && i.done).length,
    total: applicable.length,
    notApplicable: list.length - applicable.length,
  };
}

export function isFullyReady(counts) {
  return !!counts && counts.total > 0 && counts.done >= counts.total;
}

/** "Registered without: bank account, team invites" — or "" when nothing was off. */
export function planNote(plan) {
  return (plan && typeof plan.note === "string") ? plan.note : "";
}
